<script setup lang="ts">
import EmailIcon from "@/components/icons/EmailIcon.vue";
import InstagramIcon from "@/components/icons/InstagramIcon.vue";
import { computed, onMounted, ref } from "vue";
import PhoneModal from "@/components/modals/PhoneModal.vue";
import LoginButton from "@/components/buttons/LoginButton.vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSocialsStore } from "@/stores/socialsStore";

const isPhoneModalVisible = ref(false);

const socialStore = useSocialsStore();

const emailLink = computed(() => socialStore.socialLinks.email);
const instagramLink = computed(() => socialStore.socialLinks.instagram);

onMounted(async () => {
  await socialStore.loadSocials();
});

function openLoginPage() {
  router.push({ name: ROUTE_NAMES.USER });
}

function openSocialLink(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}
</script>

<template>
  <div
    class="flex px-[9px] md:px-6 justify-between items-center w-full h-16 bg-brown xl:hidden border-t border-[#4C3F3A]"
  >
    <div class="flex gap-2">
      <EmailIcon class="w-[46px] h-[46px]" type="gold" v-if="emailLink" />
      <InstagramIcon
        class="w-[46px] h-[46px]"
        type="gold"
        v-if="instagramLink"
        @click="openSocialLink(instagramLink)"
      />
    </div>
    <LoginButton class="!h-[48px]" @click="openLoginPage" />
    <PhoneModal
      v-if="isPhoneModalVisible"
      @close="isPhoneModalVisible = false"
    />
  </div>
</template>
